<template>
  <Form ref="form" class="shadow-lg card mx-auto max-400" @submit.prevent>
    <div class="card-body">
      <Logo />
      <div class="mt-5">
        <input
          ref="focused" v-model="credential.username" type="email" autocomplete="username"
          class="form-control py-2" maxlength="64" :placeholder="$t('email')"
          required @vue:mounted="$event.el.focus()"
        >
      </div>
      <div class="mt-2">
        <input
          v-model="credential.password" type="password" autocomplete="current-password"
          class="form-control py-2" minlength="4" maxlength="16" :placeholder="$t('senha')" required
        >
      </div>
      <div v-if="emailSenhaIncorreta" class="mt-2">
        <span class="text-danger">{{ $t("emailSenhaIncorreta") }}</span>
      </div>
      <div class="mt-4 ms-2 text-start">
        <div class="form-check-inline form-switch me-1">
          <input v-model="credential.keepOn" type="checkbox" class="form-check-input switch-large" role="switch">
        </div> {{ $t("mantenhaMeConectado") }}
      </div>
      <LoadingButton class="btn-primary w-100 mt-5" :loading="loading" large @click="submit">
        {{ $t("entrar") }}
      </LoadingButton>
      <RescuePassDialog />
      <Copyright />
    </div>
  </Form>
</template>

<script>
import Form from '@/modules/core/components/FormInput.vue';
import Logo from './LogoLogin.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import RescuePassDialog from './RescuePassDialogLogin.vue';
import Copyright from './CopyrightLogin.vue';

export default {
  components: {
    Form,
    Logo,
    LoadingButton,
    RescuePassDialog,
    Copyright,
  },
  props: {
    loading: { type: Boolean, required: true },
    emailSenhaIncorreta: { type: Boolean, required: true },
  },
  emits: ['authenticate'],
  data: () => ({
    credential: { username: null, password: null, keepOn: false },
  }),
  methods: {
    submit() { !this.loading && this.$refs.form.validate() && this.$emit('authenticate', this.credential); },
  },
};
</script>

<style scoped>
.max-400 {
  max-width: 400px;
}
</style>
